import type { DataSourceDataParams } from "@infinite-table/infinite-react";
import type { BacktestItem } from "epsm-api-types/models";
import { useEffect } from "react";

export function useFetchNextPage(
	dataParams: Partial<DataSourceDataParams<BacktestItem>>,
	isFetchingNextPage: boolean,
	isLoading: boolean,
	fetchNextPage: () => void,
) {
	// biome-ignore lint/correctness/useExhaustiveDependencies: correct deps array
	useEffect(() => {
		if (isFetchingNextPage || isLoading) {
			return;
		}

		if (dataParams.livePaginationCursor !== undefined) {
			fetchNextPage();
		}
	}, [dataParams.livePaginationCursor]);
}
